<template>
  <div class="panel-tabs-wrap">
    <div class="panel-tabs-header">
      <!-- TODO SLOT HEADER -->
      <slot name="header"></slot>
    </div>
    <div class="panel-tabs white-background">
      <div class="panel-tabs__tools">
        <!-- TODO SLOT TOOLS -->
        <slot name="tools"></slot>
      </div>
      <div class="panel-tabs__tabs">
        <div
          v-for="(tab, i) in tabList"
          :key="i"
          class="panel-tabs__tab-item"
          :class="{'is-active': tab.name === activeTab}"
          @click="handleChangeTab(tab.name)"
        >
          <!-- TODO SLOT TAB ITEM TITLE -->
          <slot name="tab-item-title" :tab="tab"></slot>
        </div>
      </div>
      <div class="panel-tabs__select">
        <el-form>
          <el-form-item
            :label="L10n('select-tab')"
            class="material-style"
          >
            <el-select
              :value="activeTab"
              @change="handleChangeTab"
            >
              <el-option
                v-for="tab in tabList"
                :key="tab.name"
                :label="L10n(tab.name)"
                :value="tab.name"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div class="panel-tabs__content">
        <!-- TODO SLOT TAB ITEM CONTENT-->
        <slot name="content" :tab="currentTab"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PagePanelTabs',
  props: {
    tabList: { type: Array, default: () => ([]) },
    renderOne: { type: Boolean, default: true },
    activeTab: { type: String }
  },
  computed: {
    mapTabs () {
      return this.tabList.reduce((result, item) => {
        result[item.name] = item
        return result
      }, {})
    },
    currentTab () {
      return this.mapTabs[this.activeTab]
    }
  },
  methods: {
    handleChangeTab (name) {
      this.$emit('update:activeTab', name)
    }
  }
}
</script>

<style lang="stylus">
  .panel-tabs-wrap{
    width 100%
    height 100%
    display flex
    flex-direction column
  }
  .panel-tabs-header{
  }
  .panel-tabs{
    flex 1
    display grid
    grid-template-areas:
    "select tools"\
    "tabs content"
    grid-template-rows auto 1fr
    grid-template-columns 20% 1fr
    grid-gap 0px
    padding 0
    > * {
      min-width 0
    }
  }
  .panel-tabs__tools{
    grid-area tools
    background #f2fbfe
    padding 2rem 1.5rem
    position relative
    z-index 2
    border-left 1px solid #eeeeef
  }
  .panel-tabs__select{
    grid-area select
    padding 2rem 1.5rem
    display none
  }
  .panel-tabs__tabs{
    grid-area tabs
    border-right 1px solid #eeeeef
    border-top 1px solid #eeeeef
  }
  .panel-tabs__content{
    grid-area content
    border-top 1px solid #eeeeef
    padding 2 rem
  }
  .panel-tabs__tab-item{
    cursor pointer
    padding 0 1.5rem
    height: 61px
    line-height: 61px
    display block
    list-style none
    font-size 14px
    position relative
    border-bottom 1px solid #eeeeef
    color #65646c
    text-transform capitalize
    font-weight bold
    text-overflow ellipsis
    white-space nowrap
    overflow hidden
    &.is-active{
      color #06aaea
      &:after{
        transform: scale(1)
      }
    }
    &.is-disabled{
      cursor auto
      color #b0afb5
    }
    &:after{
      content ''
      display block
      position absolute
      width 100%
      left 0
      bottom 0
      background: #06aaea
      height: 2px
      transform: scale(0, 1)
      transition: transform 0.3s ease
    }
  }
  @media only screen and (max-width: 992px) {
    .panel-tabs{
      flex-grow 1
      display grid
      grid-template-areas:
        "tools"\
        "select"\
        "content"
      grid-template-rows auto auto 1fr
      grid-template-columns 1fr
      grid-gap 0px
      padding 0
    }
    .panel-tabs__select{
      display block
    }
    .panel-tabs__tabs{
      display none
    }
  }
</style>
